// One section per command in the integration's flow, each rendering its own slice
// of the location settings schema.

import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@decisiv/ui-components';

import {
  DynamicFormSection,
  resolveLocationSettingsKind,
} from '../../features/dynamic-form';
import { FormDivider, FormGroup, SectionRow } from '../StyledComponents';
import CommandIconAndTitle from '../CommandIconAndTitle';
import AppJsonEditor from './AppJsonEditor';

// One section per command in the flow, each rendering its own slice of the
// schema through the shared dynamic-form module.
const SchemaSections = ({
  schema,
  form,
  readOnly,
  texts = undefined,
  encryptText,
  onOpenSchemaDetails,
  onHeaderValidate,
}) => (
  <>
    {Object.keys(schema).map((classification) => (
      <SectionRow key={classification}>
        <Grid.Column span="2">
          <CommandIconAndTitle
            title={classification}
            onClick={() => onOpenSchemaDetails(classification)}
          />
        </Grid.Column>
        <Grid.Column key={`Column${classification}`}>
          <DynamicFormSection
            descriptors={schema[classification]}
            form={form}
            resolveKind={resolveLocationSettingsKind}
            readOnly={readOnly}
            texts={texts}
            encryptText={encryptText}
            jsonEditor={AppJsonEditor}
            wrapper={FormGroup}
            onHeaderValidate={onHeaderValidate}
          />
          <FormDivider />
        </Grid.Column>
      </SectionRow>
    ))}
  </>
);

SchemaSections.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  schema: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  texts: PropTypes.object,
  encryptText: PropTypes.func.isRequired,
  onOpenSchemaDetails: PropTypes.func.isRequired,
  onHeaderValidate: PropTypes.func.isRequired,
};
export default SchemaSections;
